import { render, staticRenderFns } from "./AppAutosizeTextarea.vue?vue&type=template&id=143bdc14"
import script from "./AppAutosizeTextarea.vue?vue&type=script&lang=js"
export * from "./AppAutosizeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\nakatsukasa\\Herd\\cms.insag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143bdc14')) {
      api.createRecord('143bdc14', component.options)
    } else {
      api.reload('143bdc14', component.options)
    }
    module.hot.accept("./AppAutosizeTextarea.vue?vue&type=template&id=143bdc14", function () {
      api.rerender('143bdc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/common/components/AppAutosizeTextarea.vue"
export default component.exports